function Chip({ children, tone = 'default', className = '' }) {
  const tones = {
    default: 'border-line bg-surface text-ink-soft',
    accent: 'border-accent/15 bg-accent-soft text-accent-deep',
    inverse: 'border-white/15 bg-white/10 text-white'
  };

  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 text-[13px] font-medium leading-5 ${tones[tone]} ${className}`}
    >
      {children}
    </span>
  );
}

export default Chip;
